import '../assets/scss/index.scss'

import { Box, Typography, Container, useMediaQuery } from '@mui/material'
import Btn from '../components/Btn'
import AllRequestsBtn from '../components/AllRequestsBtn'
import InputField from '../components/InputField'
import SupportPost from '../components/SupportPost'
import { useTheme } from '@mui/material/styles'
// import FileUpload from '../components/FileUpload'
import { useGetSupportDetailsTicketMutation, usePostMessageMutation } from '../redux/api/supportApi'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { PATH } from '../routes/constant'
import Loader from '../components/Loader/Loader'
import useToken from '../hooks/useToken'
import { type IChatMessage, type IUserProfile } from '../redux/api/types'
import { useSelector } from 'react-redux'
import { setRouteParams } from '../utils/setRouteParams'

const SupportDetailsPage: React.FC = () => {
  const navigate = useNavigate()
  const ref = useRef<any>(null)
  const [mess, setMess] = useState('')
  const {
    xsrf,
    isLoading: isLoadingXSRF
  } = useToken()

  const params = useParams()
  setRouteParams(params)
  const { id } = params
  const [getDetails, {
    data,
    isLoading,
    isSuccess
  }] = useGetSupportDetailsTicketMutation()
  const [sendMessage, {
    isSuccess: isSuccessSend,
    isLoading: isLoadingSend
  }] = usePostMessageMutation()

  useEffect(() => {
    getDetails({ id: id ?? '' }).then().catch(() => {
    })
  }, [isSuccessSend])

  const scrollToElement = () => {
    ref.current?.scrollIntoView({ behavior: 'smooth' })
  }

  useEffect(() => {
    scrollToElement()
  }, [isSuccess])

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const user: IUserProfile = useSelector((state: any) => state.userState.user)

  const sendUserMessage = () => {
    sendMessage({
      id: id ?? '',
      token: xsrf,
      content: mess
    }).then(() => {
      setMess('')
    }).catch(() => {
    })
  }

  const renderedMessages = useMemo(() => {
    const sortedMessages = data?.chatMessages
      ? [...data.chatMessages].sort((a: IChatMessage, b: IChatMessage) => {
          return new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime()
        })
      : []

    return sortedMessages.map((message: IChatMessage) => (
            <SupportPost
                senderName={message.senderName}
                isClient={message.isClient}
                date={message.createdDate}
                key={message.createdDate}
            >
                <Box dangerouslySetInnerHTML={{ __html: message.content }}/>
            </SupportPost>
    ))
  }, [data?.chatMessages])

  if (isLoading || isLoadingXSRF) {
    return <Box sx={{ marginTop: '200px' }}><Loader/></Box>
  }

  return (
        <Box sx={{
          px: isMobile ? 2 : 5,
          pb: 3
        }}>
            <Box onClick={() => {
              navigate(PATH.SUPPORT)
            }} sx={{
              pt: isMobile ? 0 : 3,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              position: 'sticky',
              top: 0,
              width: isMobile ? '100%' : 'calc(100% - 80px)',
              backgroundColor: theme.palette.grey[98],
              zIndex: 1
            }}>
                <AllRequestsBtn/>
                <Typography align='right' sx={{
                  flexGrow: 1,
                  my: '5px',
                  fontSize: 16,
                  fontWeight: 900,
                  lineHeight: '20px',
                  color: '#7D8FB3'
                }}>
                    {data?.ticket?.number}
                </Typography>
            </Box>
            <Typography align='center' variant='h2' sx={{
              color: theme.palette.grey[40],
              fontWeight: 900,
              position: 'sticky',
              top: isMobile ? '40px' : '65px',
              width: isMobile ? '100%' : 'calc(100% - 80px)',
              backgroundColor: theme.palette.grey[98],
              zIndex: 2
            }}>{data?.ticket?.subject}</Typography>
            <Typography align='center' variant='h6' sx={{
              color: data?.ticket?.status === 'Open' ? '#13BF24' : '#7D8FB3',
              fontWeight: 900,
              position: 'sticky',
              top: isMobile ? '70px' : '90px',
              width: isMobile ? '100%' : 'calc(100% - 80px)',
              backgroundColor: theme.palette.grey[98],
              zIndex: 2
            }}>{data?.ticket?.status}</Typography>
            <Box>
                <Box sx={{
                  mx: isMobile ? 2 : 5,
                  marginTop: isMobile ? '10px' : '20px'
                }}>
                    <Container
                        maxWidth='md'
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignContent: 'center',
                          justifyContent: 'center'
                        }}
                        style={{ padding: 0 }}
                    >
                        <Box sx={{
                          paddingBottom: isMobile ? '10px' : '20px'
                        }}>

                            <SupportPost date={data?.ticket?.createdDate ?? ''} isClient={true}
                                         senderName={user.account.name}>
                                <Box dangerouslySetInnerHTML={{ __html: data?.description ?? '' }}/>
                            </SupportPost>
                            {renderedMessages}
                            <Box ref={(node) => {
                              ref.current = node
                            }}/>
                        </Box>
                        <InputField
                            id="outlined-multiline-flexible"
                            value={mess}
                            onChange={(e) => {
                              setMess(e.currentTarget.value)
                            }}
                            label="Reply to Support"
                            multiline
                            rows={3}
                            maxRows={6}
                            sx={{
                              position: 'sticky',
                              paddingTop: '10px',
                              bottom: isMobile ? '55px' : '70px',
                              width: '100%',
                              maxWidth: '768px',
                              backgroundColor: theme.palette.grey[98],
                              zIndex: 2
                            }}
                        />
                        <Box sx={{
                          my: 1,
                          mr: isMobile ? 0 : 5,
                          flexGrow: 1,
                          display: 'flex',
                          gap: '15px',
                          justifyContent: 'space-between',
                          position: 'sticky',
                          bottom: 0,
                          paddingTop: isMobile ? '10px' : '20px',
                          paddingBottom: '10px',
                          maxWidth: '768px',
                          width: '100%'
                        }}>
                            <Btn disabled={isLoadingSend} onClick={sendUserMessage} variant='contained'
                                 color='secondary'
                                 text='Post Message'/>
                            <Box />

                        </Box>
                    </Container>
                </Box>
            </Box>
        </Box>
  )
}

export default SupportDetailsPage
